/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/

import moment from 'moment-timezone';

import localeDateInputOrder from '@/helpers/locale-date-input-order';



const validateMonthDayAndYear = (value) => {
  if (value == null || value === '') return true;

  const formatIsValid = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(value);
  const parseFormat = localeDateInputOrder() === 'DMY' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
  const date = moment(value, parseFormat, true);
  const dateIsvalid = date.isValid();

  if (formatIsValid && dateIsvalid) {
    return true;
  }

  return `Invalid date (${parseFormat}).`;
};



export default validateMonthDayAndYear;
